// extracted by mini-css-extract-plugin
export default {"orange_button":"BtnOrange_orange_button__YyePc"};